'use client';

import { TLocation } from '@/app/(blogposts)/blog/blog.types';
import { Typography } from '@/components/ui/Text';
import { assetUrl } from '@/lib/directus/assetUrl';
import clsx from 'clsx';
import Image from 'next/image';
import { useCallback } from 'react';

import './BlogArticleModuleCentersCardDesktop.scss';

type Props = {
  location: TLocation;
  onClick: () => void;
  focused?: boolean;
  className?: string;
  textColor?: string;
};

export const BlogArticleModuleCentersCardDesktop: React.FC<Props> = ({
  location: { previewImage, label, clinics, slug },
  onClick,
  focused = false,
  className,
  textColor,
}) => {
  const handleLocationRedirect = useCallback(() => {
    if (!slug) return;

    window.open(`/locations#${slug}`, '_blank', 'noopener');
  }, [slug]);

  return (
    <div
      className={clsx('BlogArticleModuleCentersCardDesktop', className, {
        'BlogArticleModuleCentersCardDesktop--focused': focused,
      })}
      onClick={focused ? undefined : onClick}
    >
      <Image
        src={assetUrl(previewImage) || ''}
        alt='center preview'
        fill
        className='BlogArticleModuleCentersCardDesktop__image'
      />

      <div className='BlogArticleModuleCentersCardDesktop__image-overlay' />

      <div
        className='BlogArticleModuleCentersCardDesktop__content'
        onClick={handleLocationRedirect}
        style={{ color: textColor }}
      >
        <Typography
          className='BlogArticleModuleCentersCardDesktop__title'
          variant='body'
        >
          {label}
        </Typography>

        <Typography
          className='BlogArticleModuleCentersCardDesktop__subtitle'
          variant='body-small'
        >{`${clinics.length} clinics`}</Typography>
      </div>

      <div
        className='BlogArticleModuleCentersCardDesktop__icon-wrapper'
        onClick={focused ? onClick : undefined}
      >
        <div className='BlogArticleModuleCentersCardDesktop__icon-content'>
          <div className='BlogArticleModuleCentersCardDesktop__white-circle'>
            {!focused && (
              <svg
                className='BlogArticleModuleCentersCardDesktop__white-circle-content'
                width='14'
                height='14'
                viewBox='0 0 14 14'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M6.98649 1L6.9985 13M13 7.0015L1 7.0015'
                  stroke='#292722'
                  strokeWidth='2'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </svg>
            )}

            {focused && (
              <svg
                className='BlogArticleModuleCentersCardDesktop__white-circle-content'
                width='14'
                height='2'
                viewBox='0 0 14 2'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M13 1L1 1'
                  stroke='#292722'
                  strokeWidth='2'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </svg>
            )}
          </div>
        </div>
      </div>

      {focused && (
        <div className='BlogArticleModuleCentersCardDesktop__center-preview'>
          {clinics.map(item => (
            <div
              className='BlogArticleModuleCentersCardDesktop__center'
              key={item.id}
            >
              <div className='BlogArticleModuleCentersCardDesktop_center-name'>
                {item.name}
              </div>

              <div className='BlogArticleModuleCentersCardDesktop__center-address'>
                {item.address}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
